export default __webpack_public_path__ + "static/media/cash.d79acb6a.svg";